import React from "react";
import AllReview from "../../components/Review/AllReview";
import MainWrapper from "../../Wrapper/MainWrapper";
import { reviewRefrencePageArr } from "../../components/Review/AllReview";

const Page =()=>{
    return <>
    <MainWrapper>
    {/* <h1>Review</h1> */}
    <AllReview refrencePage={reviewRefrencePageArr[0]} orderDetail={''} />
    </MainWrapper>
    </>
}

export default Page;